import { getPrimaryFocusTerms } from '@/graphql-fragments/getPrimaryFocusTerms'
import { mapTermsToPrimaryFocus } from '@/domain/term/useCases/mapTermsToPrimaryFocus'

export const createPrimaryFocusMap = () => {
  const terms = getPrimaryFocusTerms()
  const primaryFocusMap = mapTermsToPrimaryFocus(terms)
  return primaryFocusMap
}
